export default __webpack_public_path__ + "static/media/rootimmunity.06865754.png";